import { render, staticRenderFns } from "./BlogSearch.vue?vue&type=template&id=f2da569e&lang=pug&"
import script from "./BlogSearch.vue?vue&type=script&lang=js&"
export * from "./BlogSearch.vue?vue&type=script&lang=js&"
import style0 from "./BlogSearch.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports